import User from '../../../api/User';
import * as types from './mutation-types';

export const getUserLessonTopics = async ({ commit }, { id }) => {
    const json = await new User().getUserLessonTopics(id);

    commit(types.LESSON_TOPICS, json.data);
};


export default {
    getUserLessonTopics,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js